// @ts-nocheck
import { PackagingAdviceFormFieldValues } from "@store/Framework/Store/Greif/Components/PackagingAdviceForm/PackagingAdviceFormState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Array<keyof PackagingAdviceFormFieldValues>;
type HandlerType = Handler<Parameter>;

export const DispatchCancelDraftFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/PackagingAdviceForm/CancelDraftFieldValues",
        keys: props.parameter,
    });
};

export const chain = [DispatchCancelDraftFieldValues];

const cancelDraftFieldValues = createHandlerChainRunnerOptionalParameter(
    chain,
    [] as Parameter,
    "CancelDraftFieldValues",
);

export default cancelDraftFieldValues;
